/**
 * Whether Add SOS starts an officer unticked when their window opens at the start of the shift.
 *
 * Those officers are normally seated when the roster is generated (the SOS table in the generate wizard),
 * so re-pasting the day's running list would add them twice. On by default; personal to this user and
 * remembered on this device, so it is changed from the Settings tab without touching anyone else's.
 */
import { useSyncExternalStore } from 'react';
import { loadPref, savePref } from './prefStorage';

const STORAGE_KEY = 'orca.sosUntickShiftStart';
const listeners = new Set<() => void>();
let untick = loadPref(STORAGE_KEY) !== '0';

export function getUntickShiftStartSos(): boolean {
  return untick;
}

export function setUntickShiftStartSos(on: boolean): void {
  untick = on;
  savePref(STORAGE_KEY, on ? '1' : '0');
  listeners.forEach((l) => l());
}

export function useUntickShiftStartSos(): boolean {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
    () => untick,
  );
}

/** Any of the windows opening at the shift's first slot ("HHMM"): an officer the roster seated at generation. */
export const opensShift = (windows: Array<{ st: string }>, shiftStart: string): boolean =>
  windows.some((w) => w.st === shiftStart);
